import { Type } from "../type/Type.js";
/**
 * Recursively mutates original by assigning values of assignment to original using the specified mode
 * @param original original object
 * @param assignment the object with values to assign to the original
 * @param mode the mode in which to assign or set values: append = only inject new values, update = only update existing values, and merge = recursively create or replace, upsert = update/replace top level keys only (no recursive merge)
 * @param cloneAssignment whether to clone the assignment object before assigning
 */
function objectJoin(original, assignment, mode = 'merge', cloneAssignment = false, replaceArraysWhenMerging = false) {
    // throw an error if: original isn't a primitive iterable (array or object)  OR  original and assignment aren't the same type
    if (!Type.isPrimitiveIterable(original) || Type.typeOf(original) !== Type.typeOf(assignment)) {
        throw new Error('Error: InvalidArgumentTypeCombination. The arguments "original" and "assignment" must be the same type and be a primitive iterable (array or object).');
    }
    // clone assignments if specified
    if (cloneAssignment) {
        assignment = Type.clone(assignment);
    }
    switch (mode) {
        // walk down and overwrite leaf keys, create anthying along the way that doesn't exist including new leafs
        case 'merge':
            // iterate assignment's keys
            for (const key in assignment) {
                // if original has the key AND the children are the same primitive iterable types, walk in
                if (original.hasOwnProperty(key) && (Type.isObject(original[key]) || (Type.isArray(original[key]) && replaceArraysWhenMerging === false)) && Type.areSameType(original[key], assignment[key])) {
                    objectJoin(original[key], assignment[key], mode, false, replaceArraysWhenMerging);
                }
                // otherwise assign
                else {
                    original[key] = assignment[key];
                }
            }
            break;
        // walk down and append (create) anything that does NOT already exist
        case 'append':
            // iterate assignment's keys
            for (const key in assignment) {
                // if the child does NOT exist in original, append it
                if (!original.hasOwnProperty(key)) {
                    original[key] = assignment[key];
                }
                // otherwise, we know original has the key, and if the child elements are the same primitive iterable type, we walk in to check deeper appending
                else if (Type.isPrimitiveIterable(assignment[key]) && Type.areSameType(original[key], assignment[key])) {
                    objectJoin(original[key], assignment[key], mode, false, replaceArraysWhenMerging);
                }
                // otherwise, do nothing
                else {
                }
            }
            break;
        // walk down and update anything that DOES exist
        case 'update':
            // iterate assignment's keys
            for (const key in assignment) {
                // first, we only consider updating if original[key] exists in the first place
                if (original.hasOwnProperty(key)) {
                    // if original[key] not a primitive iterable (i.e. not array or pure object), update it
                    if (!Type.isPrimitiveIterable(original[key])) {
                        original[key] = assignment[key];
                    }
                    // otherwise, we know original[key] is a primitive iterable so if they are both the same type walk in to check deeper updates
                    else if (Type.areSameType(original[key], assignment[key])) {
                        objectJoin(original[key], assignment[key], mode, false, replaceArraysWhenMerging);
                    }
                    // otherwise do nothing
                    else {
                    }
                }
            }
            break;
        // at the top level, add new or overwrite existing
        case 'upsert':
            // assign unconditionally for top level keys, no walking
            for (const key in assignment) {
                original[key] = assignment[key];
            }
            break;
    }
    return original;
}
export { objectJoin };
//# sourceMappingURL=objectJoin.js.map